import { Button } from "antd";
import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LoginFormLayout } from "../../../layouts/LoginFormLayout/LoginFormLayout";
import { SELECT_TYPE_POSITION } from "../../../store/selectors/authSliceLoginSelector";
import { RecoveryPasswordForm } from "../forms/RecoveryPasswordForm";
import { RecoveryPasswordSendMessage } from "../sendMessage/RecoveryPasswordSendMessage";

import classes from "./RecoveryPassword.module.css";

export function RecoveryPassword(): ReactElement {
  const userTypePosition = useSelector(SELECT_TYPE_POSITION);

  if (userTypePosition === "PASSWORD_RECOVERY") {
    return <RecoveryPasswordSendMessage />;
  }

  return (
    <LoginFormLayout name={"Восстановление пароля"}>
      <RecoveryPasswordForm />
      <Link to="/login">
        <Button
          size="large"
          variant="outlined"
          className={classes.recoveryPassSignLink}
        >
          Войти
        </Button>
      </Link>
    </LoginFormLayout>
  );
}
